import { disableScroll, enableScroll, isTouchDevice } from './utilities'

export const initHeader = () => {
  const hamburger = document.getElementById('hamburger')
  hamburger.addEventListener('input', () => {
    const fullscreenMenu = document.querySelector('.header__menu .header__menu__wrap')
    document.body.classList.toggle('open-menu', hamburger.checked)

    if(fullscreenMenu){
      if(hamburger.checked){
        disableScroll(fullscreenMenu)
      }else{
        enableScroll(fullscreenMenu)
      }
    }
  })
  document.addEventListener('scroll', () => {
    document.body.classList.toggle('scrolled', window.scrollY > 60)
  })
  const header = document.querySelector('.header')
  const productLinks = document.querySelectorAll('.header__menu__products li')
  productLinks.forEach((productLink) => {
    let classes = productLink.classList
    const anchorClass = classes[classes.length - 1]
    productLink.addEventListener('mouseenter', () => { if(!isTouchDevice()) header.classList.add(anchorClass) })
    productLink.addEventListener('mouseleave', () => { header.classList.remove(anchorClass) })
  })
}

export const headerHeight = () => {
  const header = document.querySelector('.header')
  let currentHeight = 0;
  const headerHandler = () => {
    if(currentHeight !== header.clientHeight){
      currentHeight = header.clientHeight
      document.documentElement.style.setProperty('--header', `${currentHeight}px`);
    }
  }
  window.addEventListener('resize', () => {
    headerHandler()
  })
  headerHandler()
}
